module.exports = __webpack_public_path__ + "static/molo_w_pucku_4-cf1b257d7b3258f28172493f5a413d28.svg";